import http from '@core/fetch'
import { API_SETMEAL_CATEGORY_ALL } from '@constant'

export default {
  // 获取案例属性
  getMealMarks: params =>
    http.get('/p/wedding/index.php/admin/APISetMeal/mealMarks', {
      body: params
    }),

  // 获取案例信息配置
  getInputConfig: params =>
    http.get('/p/wedding/index.php/admin/APISetMeal/field?commodity_type=1', {
      body: params
    }),

  // 获取案例分类
  getCaseCate: params =>
    http.get(API_SETMEAL_CATEGORY_ALL, {
      body: params
    }),

  // 增加案例分类
  addCaseCate: params =>
    http.post('/p/wedding/Admin/APISetMealMerchantCategory/Add', {
      body: params
    }),

  // 增加案例
  addCase: (params, xywh) =>
    http.post(`/p/wedding/index.php/admin/APISetMeal/add${xywh}`, {
      body: params,
      ignore: [null, undefined]
    }),

  // 获取案例详情
  getCase: params =>
    http.get('/p/wedding/index.php/admin/APISetMeal/info', {
      body: params
    }),

  // 编辑案例
  editCase: (params, xywh) =>
    http.post(`/p/wedding/index.php/admin/APISetMeal/edit${xywh}`, {
      body: params,
      ignore: [null, undefined]
    }),

  // 案例类目
  getCaseProperties: params =>
    http.get('/p/wedding/Admin/APISetMeal/properties', {
      body: params
    }),

  // 获取门店配置
  getStoreConfig: () => {
    return http.get('/hms/hljStore/api/modules')
  },

  // 获取客照
  getKeZhaos: body =>
    http.get('/p/wedding/index.php/Admin/APIMealRelation/WorkList', { body }), // 获取可选客照
  // 搜索酒店
  getHotels: body =>
    http.get('/p/wedding/index.php/admin/APIHotelMerchant/SearchHotel', {
      body
    }),
  // 高定标签列表
  getTopWeddingTag: body =>
    http('/hps/admin/figure/topWedding/topLabel', {
      body
    }),
  // 策划师列表-不分页
  getPlanner: () => http('/hps/admin/figure/planner/planner'),

  // 摄影师列表-不分页
  getPhotographers: () => http('/hps/admin/figure/photographer/photographers'),

  // 套餐案例名称敏感词检查
  checkWord: body =>
    http.post('/hps/admin/localServerMerchant/index/setMealSensitiveWord', {
      body,
      ignore: []
    }),
  saveDraft: body =>
    http.post('/hms/merchant/appApi/draftCase/edit', {
      body
    }),
  delDraft: body =>
    http.post('/hms/merchant/appApi/draftCase/delete', {
      body,

      onError: false
    }),
  deleteSetMeal: params =>
    http.post('/p/wedding/index.php/Admin/APISetMeal/delete', {
      body: params,
      onError: false
    }), //删除普通套餐

  getDraftDetail: body =>
    http('/hms/merchant/appApi/draftCase/detail', {
      body
    }),

  getByCityCode: body =>
    http('/hms/hljLocalserviceProduct/adminApi/scenicSpot/getByCityCode', {
      body
    })
}
